import { Injectable } from "@angular/core";

import { ToastrService } from "ngx-toastr";
import { UserRightsService } from "../user-rights/user-rights.service";

@Injectable({
	providedIn: "root",
})
export class AuthGuardService  {
	constructor(private auth: UserRightsService, private toastService: ToastrService) {}
	canActivate(): boolean {
		if (!this.auth.IsLoggedIn()) {
			this.toastService.info("You do not have an active session.","Please Login", {timeOut: 8000} );
			this.auth.Logout();
			return false;
		}

		return true;
	}
}
